import { createTypedOutlet } from "src/router";

import { EventSourceQuery } from "src/graphql";
import { EventSourceDefinition } from "src/events/types";

export type EventSourceOutletContext = {
  source: NonNullable<EventSourceQuery["event_sources_by_pk"]>;
  definition: EventSourceDefinition;
};

const {
  OutletProvider: EventSourceOutlet,
  useContext: useEventSourceOutletContext,
  useOptionalContext: useEventSourceOutletContextIfAvailable,
} = createTypedOutlet<EventSourceOutletContext>("EventSource");

export {
  EventSourceOutlet,
  useEventSourceOutletContext,
  useEventSourceOutletContextIfAvailable,
};
